// extracted by mini-css-extract-plugin
export default {"main_container":"Container_main_container__SgfGH"};